import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class RoleGuard implements CanActivate {


  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = localStorage.getItem('token');
    const role = localStorage.getItem('roleId');
    if (currentUser && role == '1') {
      return true;
    } else if (currentUser && role == '3'){
      return true;
    } else if (currentUser && role == '5') {
      return true;
     }

    this.router.navigate(['user-login']);
    return false;

   
  }

  // canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
  //   const admin = localStorage.getItem('isAdmin');

  //   if (admin) {
  //     return true;
  //   }

  //   // navigate to not found page
  //   this._router.navigate(['/404']);
  //   return false;
  // }

}
